import { lazy, type FC } from 'react';
import { Route } from 'react-router-dom';
import { useRemitReportingEntrypoint } from 'src/apis/remit-reporting/use-remit-reporting-entrypoint';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { useTitle } from 'src/hooks/use-title';

const Page = lazy(() => import('./page'));

export const RemitReportingSettings: FC = () => {
  useTitle('Settings - REMIT Reporting');
  const remitReportingService = useRemitReportingEntrypoint();
  if (!remitReportingService.response) return <PageSpinner />;

  return (
    <RootRoutes>
      <Route
        path="/settings/remit-reporting"
        element={
          <Page remitReportingService={remitReportingService.response.data} />
        }
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
